/**
 * YouTube RSS Feed Service
 * Fetches and parses the YouTube XML feed via a local same-origin proxy.
 */

const CHANNEL_ID = 'UC3rGOiJqbS4qkW2EcYSDv2g';
// Local proxy endpoint to avoid CORS issues
const LOCAL_PROXY_URL = '/api/youtube-feed.php';

export const fetchLatestVideos = async () => {
  try {
    // Fetch directly from our own domain's proxy
    const response = await fetch(`${LOCAL_PROXY_URL}?channelId=${CHANNEL_ID}`);
    
    if (!response.ok) {
      throw new Error(`Proxy error: ${response.status}`);
    }

    // The local proxy returns the raw XML string (not wrapped in JSON like AllOrigins)
    const xmlString = await response.text();
    
    if (!xmlString || xmlString.includes('<error>')) {
      throw new Error('RSS content is invalid or contains an error');
    }

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    const entries = xmlDoc.getElementsByTagName("entry");

    if (entries.length === 0) {
      console.warn('No entries found in RSS feed');
      return [];
    }

    const videos = Array.from(entries).slice(0, 12).map(entry => {
      // Extract VIDEO_ID by taking <id>, splitting by ":", and using the last segment
      const rawId = entry.getElementsByTagName("id")[0]?.textContent || "";
      const videoId = rawId.split(':').pop();
      const title = entry.getElementsByTagName("title")[0]?.textContent || "Untitled Reflection";
      const published = entry.getElementsByTagName("published")[0]?.textContent;

      return {
        videoId: videoId,
        title: title,
        published: published,
        thumbnail: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
        link: `https://www.youtube.com/watch?v=${videoId}`
      };
    });

    return videos;
  } catch (error) {
    console.error('Error in youtube-feed service:', error.message);
    throw error;
  }
};